/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import { Container, Row, Col, Form, FormControl, Button } from 'react-bootstrap';

import CustomBackground from '../../components/UI/CustomBackground/CustomBackground';

import { useTranslation, Translation } from 'react-i18next';

import { ReactComponent as InfoCircleLightIcon } from '../../assets/infoCircleLight.svg';

import graphQLClientInstance from '../../axios-graphql-client';

import classes from './TestDenomination.module.css';

import Table, { tableOrigin } from '../../components/UI/Table/Table';

import { Formik } from "formik";
import * as Yup from "yup";

import { withRouter } from 'react-router-dom';

import Loader from '../../components/UI/Loader/Loader';

import { connect } from 'react-redux';

import * as actions from '../../store/actions';

import {
  autoCompletePostData,
  scrollToRef,
  getSubmitTestQuery,
  testDenominationFields,
  createTestDenominationFromValues,
  updateObject,
  getSubmitMultipleTestsQuery,
  getViewTestsQuery,
  isAdvanced,
  getCheckInputQuery,
  testDenominationStatus,
  API_URLS,
  getErrorTicket,
  BOOTSTRAP_CLASSES, renderTooltipOverlay
} from '../../shared/utility';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SearchFormContainer from '../../components/UI/SearchFormContainer/SearchFormContainer';
import CustomAsyncTypehead from '../../components/UI/CustomAsyncTypehead/CustomAsyncTypehead';
import { ITestDenomination } from '../../store/reducers/testDenominations';
import MultipleTestsModal from '../../components/MultipleTestsModal/MultipleTestsModal';
import { useAlert } from '../../shared/AlertService';

import { useMatomo } from '@datapunt/matomo-tracker-react';

const TestDenomination = (props: any) => {
  const { trackPageView } = useMatomo();

  React.useEffect(() => {
    trackPageView({documentTitle: "Test Denominations"});
    // eslint-disable-next-line
  }, []);

  const { t, i18n } = useTranslation();

  const {
    onAddTestDenomination,
    onAddMultipleTestDenominations
  } = props;

  const resultsRef = React.useRef(null);

  const [formValues, setFormValues] = useState([]);
  const dataRef = React.useRef();
  dataRef.current = props.testDenominations;

  const [isRefreshing, setIsRefreshing] = useState(false);
  const refreshRef = React.useRef<boolean>();
  refreshRef.current = isRefreshing;

  const [isLoading, setIsLoading] = useState(false);

  const [displayResults, setDisplayResults] = useState(false);

  const alert = useAlert();

  const isAdvancedUser = isAdvanced();
  const refreshTestData = (showLoading = false) => {
      // @ts-ignore
      if (dataRef.current?.length && refreshRef.current !== undefined && refreshRef.current === false) {
        const viewTestsReq = getViewTestsQuery(dataRef.current, showLoading);
        if (viewTestsReq.test_ids.length) {
          setIsRefreshing(true);
          if (showLoading) {
            setIsLoading(true);
          }
          graphQLClientInstance.post(API_URLS.VIEW_TESTS, viewTestsReq)
            .then(res => {
              if (res.data?.tests_list?.length) {
                props.onRefreshTestDenominations(res.data.tests_list);
              }
              setIsRefreshing(false);
              if (showLoading) {
                setIsLoading(false);
                scrollToRef(resultsRef);
              }
            })
            .catch(err => {
              setIsRefreshing(false);
              if (showLoading) {
                setIsLoading(false);
              }
              console.log(err);
            })
          }
      }
  }

  React.useEffect(() => {
    const interval = setInterval(() => {
      refreshTestData();
    }, 10000);
    return () => clearInterval(interval);
  }, []);

  const fetchData = React.useCallback(({ values }) => {
    if (values && Object.keys(values).length) {
      setIsLoading(true);

      graphQLClientInstance.post(API_URLS.SUBMIT_TESTS, getSubmitTestQuery(values))
        .then(res => {
          if (res.data?.test_ids?.length) {
            const newTest = updateObject(createTestDenominationFromValues(values, false), {test_status: testDenominationStatus.PENDING, test_id: res.data.test_ids[0]['test_id']});
            onAddTestDenomination(newTest);
          } else if (res.data?.err_message) {
            const code = getErrorTicket(res.data.err_message);
            const body = (code) ? t(`error_messages.error_ticket`, {code: code}) : t(`error_messages.${res.data.err_message}`)
            alert({
              catchOnCancel: false,
              title: t("alert"),
              body: body
            })
          }
          setIsLoading(false);
          setDisplayResults(true);
          scrollToRef(resultsRef);
        })
        .catch(err => {
          setIsLoading(false);
          console.log(err);
          alert({
            catchOnCancel: false,
            title: t("alert"),
            body: t("generic_error")
          })
        })
    }
  }, [onAddTestDenomination])

  const refreshData = React.useCallback(() => {
    refreshTestData(true);
  }, [refreshTestData])

  const selectedColumns = [
    {
      name: testDenominationFields.DENOMINATION,
      label: <Translation>{(translate) =>  translate('denomination')}</Translation>,
      enabled: true,
      isDefault: true,
      defaultOrder: 0
    },
    {
      name: testDenominationFields.SPECIES_LATIN_NAME,
      label: <Translation>{(translate) =>  translate('species_latin_name')}</Translation>,
      enabled: true,
      isDefault: true,
      defaultOrder: 1
    },
    {
      name: testDenominationFields.BREEDERS_REFERENCE,
      label: <Translation>{(translate) =>  translate('breeders_reference')}</Translation>,
      enabled: isAdvancedUser,
      isDefault: true,
      defaultOrder: 3
    },
    {
      name: testDenominationFields.BREEDERS_NAME,
      label: <Translation>{(translate) =>  translate('breeders_name')}</Translation>,
      enabled: isAdvancedUser,
      isDefault: true,
      defaultOrder: 4,
    },
    {
      name: testDenominationFields.BATCH_NAME,
      label: <Translation>{(translate) =>  translate('batch')}</Translation>,
      enabled: isAdvancedUser,
      isDefault: true,
      defaultOrder: 6,
    },
    {
      name: testDenominationFields.ADDITIONAL_INFORMATION,
      label: <Translation>{(translate) =>  translate('remark')}</Translation>,
      enabled: isAdvancedUser,
      isDefault: true,
      defaultOrder: 5,
    },
    {
      name: testDenominationFields.TEST_STATUS,
      label: "",
      accessor: testDenominationFields.TEST_STATUS,
      Header: "",
      enabled: true
    }
  ];

  const initialValues: {[key: string]: any} = {
    denomination: "",
    speciesLatinName: "",
    breedersReference: "",
    breedersName: "",
    additionalInformation: "",
    batchName: "",
    requestAdvice: false
  };

  const submitMultipleTests = React.useCallback((denominations) => {
    if (denominations && Object.keys(denominations).length) {
      setIsLoading(true);
      graphQLClientInstance.post(API_URLS.SUBMIT_TESTS, getSubmitMultipleTestsQuery(denominations))
        .then(res => {
          if (res.data?.test_ids?.length) {
            const newTests = denominations.map((value: any, index: number) =>
                                                updateObject(value, {
                                                                      test_status: testDenominationStatus.PENDING,
                                                                      test_id: res.data.test_ids[index]['test_id']
                                                                    }));
            onAddMultipleTestDenominations(newTests);
          } else if (res.data?.err_message) {
            const code = getErrorTicket(res.data.err_message);
            const body = (code) ? t(`error_messages.error_ticket`, {code: code}) : t(`error_messages.${res.data.err_message}`)
            alert({
              catchOnCancel: false,
              title: t("alert"),
              body: body
            })
          }
          setIsLoading(false);
          setDisplayResults(true);
          scrollToRef(resultsRef);
        })
        .catch(err => {
          setIsLoading(false);
          console.log(err);
          alert({
            catchOnCancel: false,
            title: t("alert"),
            body: t("generic_error")
          })
        })
    }
  }, [onAddMultipleTestDenominations])

  const [multipleTestsModalState, setMultipleTestsModalState ] = useState(false);

  const multipleTestsModal = (
    <MultipleTestsModal
      show={multipleTestsModalState}
      setShow={setMultipleTestsModalState}
      submitTests={submitMultipleTests}
    />
  );

  const cacheTest = (asyncValidate: any) => {
    let _valid = false;
    let _value = '';

    return async (value: any) => {
      if (value !== _value) {
        const response = await asyncValidate(value);
        _value = value;
        _valid = response;
        return response;
      }
      return _valid;
    };
  };

  const checkValidInput = async (value: any) => {
    let response: any = null;
    await graphQLClientInstance.post(API_URLS.CHECK_INPUT, getCheckInputQuery([value]))
    .then(res => { response = res; }).catch(err => console.log(err));
    return (response && response.data && response.data.response && response.data.response === "OK")
  }

  const validInputTest = React.useRef(cacheTest(checkValidInput));

  const form = (
    <Formik
      initialValues = {initialValues}

      validationSchema = {Yup.object().shape({
        denomination: Yup.string()
          .required(t("validation_errors.required"))
          // @ts-ignore
          .test('checkValidInput', t("invalid_characters"), validInputTest.current),
        speciesLatinName: Yup.string()
          .required(t("validation_errors.required")),
      })}
      onSubmit = {(values: any, { setFieldValue, setSubmitting }) => {
        const payload = {
          ...values
        };
        setFormValues(payload);
        setSubmitting(false);
        setIsLoading(true);
        setDisplayResults(true);
      }}>
      {formProps => (
          <Form
            className={classes.searchForm}
            onSubmit={(e) => {
              formProps.handleSubmit();
              e.preventDefault();
            }}>
            <Row className={classes.searchFieldsRow}>
              <Col md="4" id="denominationContainer">
                <Form.Group controlId="searchForm.denomination">
                  <Form.Label className={["w-100",classes.required].join(" ")}>
                    {t("denomination")}
                    {renderTooltipOverlay(
                      t("tooltips_test_denominations.denomination"),
                      <InfoCircleLightIcon />
                    )}
                  </Form.Label>
                  <FormControl
                    className={formProps.errors.denomination?BOOTSTRAP_CLASSES.IS_INVALID:""}
                    name='denomination'
                    as="input"
                    type="text"
                    value={formProps.values.denomination}
                    onChange={formProps.handleChange}
                  />
                  <Form.Control.Feedback type="invalid">
                    {formProps.errors.denomination}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md="8" id="speciesLatinNameContainer">
                <Form.Group controlId="searchForm.speciesLatinName">
                  <Form.Label className={["w-100",classes.required].join(" ")}>
                    {t("species_latin_name")}
                    {renderTooltipOverlay(
                      t("tooltips_test_denominations.species_latin_name"),
                      <InfoCircleLightIcon />
                    )}
                  </Form.Label>
                  <CustomAsyncTypehead
                    className={formProps.errors.speciesLatinName?BOOTSTRAP_CLASSES.IS_INVALID:""}
                    isInvalid={formProps.errors.speciesLatinName?true:false}
                    useCache={false}
                    selected={formProps.values.speciesLatinName}
                    newSelectionPrefix={t("typeahead_new_selection")}
                    name='speciesLatinName'
                    id='speciesLatinNameTypeahead'
                    label={t("species_latin_name")}
                    postUrl={API_URLS.GRAPHQL}
                    postData={autoCompletePostData}
                    selectFieldValue="exact"
                    includeSynonymsFieldValue={true}
                    autoCompleteName="autoCompleteSpeciesLatinName"
                    autoCompleteReturnString="{ name principal specieid }"
                    autoCompleteResponseFieldValue="specieid"
                    setFieldValue={formProps.setFieldValue}
                  />
                  <Form.Control.Feedback type="invalid">
                    {formProps.errors.speciesLatinName}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              {isAdvancedUser?(
                <React.Fragment>
                  <Col md="4" id="breedersReferenceContainer">
                    <Form.Group controlId="searchForm.breedersReference">
                      <Form.Label className="w-100">
                        {t("breeders_reference")}
                        {renderTooltipOverlay(
                          t("tooltips_test_denominations.breeders_reference"),
                          <InfoCircleLightIcon />
                        )}
                      </Form.Label>
                      <FormControl
                        name='breedersReference'
                        as="input"
                        type="text"
                        value={formProps.values.breedersReference}
                        onChange={formProps.handleChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="8" id="breedersNameContainer">
                    <Form.Group controlId="searchForm.breedersName">
                      <Form.Label className="w-100">
                        {t("breeders_name")}
                        {renderTooltipOverlay(
                          t("tooltips_test_denominations.breeders_name"),
                          <InfoCircleLightIcon />
                        )}
                      </Form.Label>
                      <FormControl
                        name='breedersName'
                        as="input"
                        type="text"
                        value={formProps.values.breedersName}
                        onChange={formProps.handleChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="12" id="additionalInformationContainer">
                    <Form.Group controlId="searchForm.additionalInformation">
                      <Form.Label className="w-100">
                        {t("remark")}
                        {renderTooltipOverlay(
                          t("tooltips_test_denominations.remark"),
                        <InfoCircleLightIcon />)}
                      </Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        name="additionalInformation"
                        maxLength={150}
                        style={{resize: 'none'}}
                        value={formProps.values.additionalInformation}
                        onChange={formProps.handleChange}
                      />
                      <span className={classes.formControlCharacterCounter}>
                        {formProps.values.additionalInformation.length}/150
                      </span>
                    </Form.Group>
                  </Col>
                  <Col md="4" id="batchNameContainer">
                    <Form.Group controlId="searchForm.batchName">
                      <Form.Label className="w-100">
                        {t("batch_name")}
                        {renderTooltipOverlay(
                          t("tooltips_test_denominations.batch_name"),
                        <InfoCircleLightIcon />)}
                      </Form.Label>
                      <FormControl
                        name='batchName'
                        as="input"
                        type="text"
                        value={formProps.values.batchName}
                        onChange={formProps.handleChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="8">
                  </Col>
                  <Col md="8" id="requestAdviceContainer">
                    <Form.Group controlId="searchForm.requestAdvice">
                      <Form.Check
                        type="checkbox"
                        name="requestAdvice"
                        label={t("request_advice")}
                        checked={formProps.values.requestAdvice}
                        onChange={(evt: React.SyntheticEvent) => formProps.setFieldValue("requestAdvice", (evt.target as HTMLInputElement).checked)}
                      />
                    </Form.Group>
                  </Col>
                </React.Fragment>
              ) :
                <Col md="8">
                </Col>
              }
              <Col md="4">
               <Button
                  id="aboutSearchAlgorithm"
                  variant="link"
                  onClick={() => window.open(`https://cpvo.europa.eu/sites/default/files/documents/cpvo_guidelines_on_art_63_with_explanatory_notes.pdf`, '_blank')}
                  className="float-right p-0 border-0">
                    {t("denomination_guidelines")}
                </Button>
              </Col>
            </Row>
            <Row className={classes.actionsRow}>
              <Col md="7">
                {isAdvancedUser?(
                  <>
                    <Col md="1" className="float-left pl-0 pr-0" style={{maxWidth: '40px'}}><FontAwesomeIcon icon={['fas', 'info-circle']} className={classes.infoCircle} /></Col>
                    <Col md="11" id="testDenominationTip" className={["float-left pl-0", classes.testDenominationTip].join(" ")}>{t("test_denomination_tip")}</Col>
                  </>
                ):<></>}
              </Col>
              <Col md="5">
                <Button
                  id="runTest"
                  variant="primary"
                  type="submit"
                  disabled={formProps.isSubmitting}
                  className="float-right">
                    {t("run_test")}
                </Button>
                <Button
                  id="runTests"
                  variant="primary"
                  type="button"
                  onClick={() => setMultipleTestsModalState(true)}
                  disabled={formProps.isSubmitting}
                  className="float-right mr-2">
                    {t("submit_batch")}
                </Button>
                <Button
                  id="help"
                  variant="link"
                  onClick={() => window.open(`help/${i18n.language}/Test_denominations.html`, '_blank')}
                  className="float-right mr-2">
                    {t("help")}
                </Button>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
  );

  const tableColumns = React.useMemo(() => {
    return [
      ...selectedColumns.map((item: any) => { return {...item, Header: item.label, accessor: item.name}})
    ]
  }, [selectedColumns]);

  return (
    <>
      <Loader show={isLoading}></Loader>
      <CustomBackground image="denomination">
        <SearchFormContainer
          title={t("test_denomination.title")}
          subtitle={t("test_denomination.subtitle")}
          >
          {form}
        </SearchFormContainer>
      </CustomBackground>
      {displayResults || props.testDenominations.length?
      <Container fluid>
        <Table
          tableRef={resultsRef}
          columns={tableColumns}
          hideColumnsButton={true}
          hideDownloadExcelButton={true}
          isSortable={false}
          data={props.testDenominations}
          fetchData={fetchData}
          refreshData={refreshData}
          pageCount={props.testDenominations.filter((test: any) => test[testDenominationFields.TEST_STATUS] === testDenominationStatus.OK).length}
          totalCount={props.testDenominations.filter((test: any) => test[testDenominationFields.TEST_STATUS] === testDenominationStatus.OK).length}
          pageIndex={0}
          formValues={formValues}
          showPagination={false}
          origin={tableOrigin.TEST_DENOMINATION}
          pageSizeOptions={[]}
        />
    </Container>
    :<></>}
    {multipleTestsModal}
  </>
  );
};

const mapStateToProps = (state: any) => {
  return {
      testDenominations: state.testDenominations.tests
  };
}

const mapDispatchToProps = (dispatch: any) => {
  return {
      onAddTestDenomination: (test: ITestDenomination) => dispatch(actions.addTestDenomination(test)),
      onAddMultipleTestDenominations: (tests: ITestDenomination[]) => dispatch(actions.addMultipleTestDenominations(tests)),
      onRefreshTestDenominations: (tests: ITestDenomination[]) => dispatch(actions.refreshTestDenominations(tests))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TestDenomination));
